import { FormControl, styled } from "@mui/material";

export const StyledFormikSelect = {
    FormControl: styled(FormControl)(({ theme }) => ({
        minWidth: 120,
        marginBottom: -3,
    })),
}